import classNames from "classnames/bind";
import { ResponsiveComponent } from "common/components/ResponsiveComponent";
import { SubText } from "common/components/Typography";
import * as React from "react";
import styles from "./ProgressBar.module.css";

const classNameBuilder = classNames.bind(styles);

interface Props {
  progression?: {
    finishedContentIds?: string[];
    allContentIds?: string[];
  };
  backgroundColor?: "grey" | "white";
  orientation?: "vertical" | "horizontal";
  withSpacing?: boolean;
  hideBarWhenCompleted?: boolean;
}

// TODO: Consider making this a SVG instead
export const ProgressBar: React.FC<React.PropsWithChildren<Props>> = ({
  progression,
  orientation = "horizontal",
  withSpacing = true,
  hideBarWhenCompleted = false,
}) => {
  if (!progression?.finishedContentIds || !progression.allContentIds) {
    return null;
  }

  const finished = progression.finishedContentIds.length;
  const total = progression.allContentIds.length;

  const classes = classNameBuilder({
    progressContainer: true,
    row: orientation === "horizontal",
    col: orientation === "vertical",
  });

  const isFinished = finished / total === 1;

  const width =
    finished === 0 || total === 0 ? 0 : `${100 * (finished / total)}%`;

  return (
    <div className={classes}>
      <SubText withSpacing={false}>
        <ResponsiveComponent
          aboveThreshold={`${finished} / ${total} elementer fullført`}
          belowThreshold={`${finished} / ${total} fullført`}
        />
      </SubText>
      {!(hideBarWhenCompleted && isFinished) && (
        <div
          className={`${styles.progressBar}${
            withSpacing ? ` ${styles.withSpacing}` : ""
          }${orientation === "vertical" ? ` ${styles.fullWidth}` : ""}`}
        >
          <div
            className={`${styles.progressBar} ${styles.progressBarFinished}`}
            style={{ width }}
          />
        </div>
      )}
    </div>
  );
};
